import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { environment } from "../../../../environments/environment"
import { ModalUploadFileService } from './modal-upload-file.service'
import { Subscription } from 'rxjs'
import { FileUploader, FileItem, FileUploaderOptions } from "ng2-file-upload"
import { ToastrService } from 'ngx-toastr'
import { AppService } from 'src/app/server/app.service';
import { ModalConfig } from '../modal.model';
import { ModalService } from '../modal.service';

export let isDebugMode = environment.isDebugMode

const URL = `${environment.api}/upload`

@Component({
  selector: 'flow-modal-upload-file',
  templateUrl: './modal-upload-file.component.html',
  styleUrls: ['./modal-upload-file.component.scss']
})
export class ModalUploadFileComponent implements OnInit {

  @ViewChild('btnClose') btnClose: ElementRef

  showError: boolean = false
  errorMessages: any = []
  stripped: boolean = false;
  subscriptions: Array<Subscription> = []
  uploaderOptions: FileUploaderOptions = {}
  uploader: FileUploader = new FileUploader({ url: URL })
  hasBaseDropZoneOver: boolean = false

  modalConfig: ModalConfig = { opened: false }

  fileOverBase(e: any): void { this.hasBaseDropZoneOver = e }

  constructor(
    public appService: AppService,
    private modalService: ModalService,
    private toastr: ToastrService) {

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      try {
        let result = JSON.parse(JSON.parse(response).output.result)
        if (result.statuscode != '200') {
          item.isSuccess = false
          item.isError = true
          item.message = result.error.message
          this.toastr.error(`Erro no upload ! ${result.error.message}`, 'Erro')
          this.errorMessages.push(
            {
              filename: item.file.name,
              message: result.error.message
            }
          )
        } else {
          this.toastr.success(`Item incluído com sucesso !`, 'Sucesso')
        }
      } catch (error) {
        this.toastr.error(`Erro no upload ! ${error}`, 'Erro')
        this.errorMessages.push(
          {
            filename: item.file.filename,
            message: error
          }
        )
      }
    }

    this.uploader.onErrorItem = (item: any, response: any, status: any, headers: any) => {
      this.toastr.error(`Erro no upload ! ${response}`, 'Erro')
      //console.log(response)
    }


    // Não deixe inserir arquivos duplicados
    this.uploader.onAfterAddingFile = (file) => {

      file.withCredentials = false; //para evitar problema de CORS

      if (this.uploader.queue.filter(q => { return q.file.name == file.file.name }).length > 1) {
        for (var i = 0;i < this.uploader.queue.length;i++) {
          if (this.uploader.queue[i].file.name === file.file.name) {
            this.uploader.queue[i].remove()
            return
          }
        }
      }

    }

    this.uploader.onBeforeUploadItem = (fileItem: any) => {
      this.uploaderOptions.headers = [];
      this.uploaderOptions.headers.push({ name: 'groupid', value: this.appService.session.groupid.toString() });
      this.uploaderOptions.headers.push({ name: 'tableid', value: this.appService.tableid });
      this.uploaderOptions.headers.push({ name: 'passportid', value: this.appService.session.passportid.toString() });
      this.uploaderOptions.headers.push({ name: 'recidkey', value: this.appService.recidkey });
      this.uploader.setOptions(this.uploaderOptions)
    }

  }

  ngOnInit() {
    this.subscriptions.push(
      this.modalService.modalConfig.subscribe(config => {
        if (config.modal == 3) {
          this.modalConfig = config
        }
      })
    )

  }


  ngOnDestroy() {
    isDebugMode ? console.log(`ngOnDestroy()`) : undefined
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe()
    })
  }

  close() {
    isDebugMode ? console.log(`close()`) : undefined
    //console.log('close modal')
    this.modalService.modalConfig.emit({ modal: 3, opened: false })
  }

  closeError() {
    this.showError = !this.showError
  }


}
